import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PasswordWrapper = styled.div`
  position: relative;
`

export const IconButtonWrapper = styled.figure`
  position: absolute;
  top: 32px; /* this is a placement with had to count also a label's height, that's why I put a hardcoded value */
  right: ${Spacing.S12};
  z-index: 1;
`
